import { useTranslation } from "react-i18next";
import { useApi } from "../hooks/useApi";
import { api } from "../lib/api";

/**
 * Slim footer surfacing the running build. Lets an operator confirm which
 * version an installation runs without shell access — see issue #7.
 */
export function AppFooter(): JSX.Element | null {
  const { t } = useTranslation();
  const version = useApi(() => api.version(), []);

  if (version.status !== "ready") {
    return null;
  }

  const { version: v, git_sha } = version.data;
  const label = git_sha ? `${v} · ${git_sha}` : v;

  return (
    <footer className="app-shell__footer">
      <span className="app-shell__version" title={t("footer.versionTitle")}>
        {t("footer.version", { version: label })}
      </span>
    </footer>
  );
}
